import qs from 'qs';
import { getFromLocalStorage } from './localStorage';

import { TEST_PG_QUERY_PATTERN } from './consts';

const getQueryFromHashHistory = (hash) => {
  const [, query] = hash.split('?');

  return query;
};

const generatePathnameForBrowserHistory = (query) => {
  return window.location.pathname + query;
};

const generatePathnameForHashHistory = (query) => {
  const { hash, pathname } = window.location;

  const [route] = hash.split('?');

  return `${pathname}${route}${query}`;
};

export const checkPaymentTestModeOn = (localStorageTestPgKey) => {
  const hashRoutingQuery = getQueryFromHashHistory(window.location.hash);
  const testPqInQuery = hashRoutingQuery
    ? hashRoutingQuery.match(TEST_PG_QUERY_PATTERN)
    : window.location.search.match(TEST_PG_QUERY_PATTERN);

  let testPgInLS = null;

  if (localStorageTestPgKey) {
    testPgInLS = getFromLocalStorage(localStorageTestPgKey);
  }

  if (!testPqInQuery && !testPgInLS) {
    return false;
  }

  if (testPgInLS === 'true') {
    return true;
  }

  if (testPqInQuery) {
    const [, testPgValue] = testPqInQuery[0].split('=');

    if (testPgValue === 'true') {
      return true;
    }

    if (testPgValue === 'false' && testPgInLS === 'true') {
      return true;
    }

    if (testPgInLS === 'false') {
      return false;
    }
  }

  return false;
};

export const toggleTestPaymentMode = () => {
  const hashRoutingQuery = getQueryFromHashHistory(window.location.hash);
  const currentQuery = hashRoutingQuery
    ? qs.parse(hashRoutingQuery)
    : qs.parse(window.location.search, { ignoreQueryPrefix: true });

  let nextQuery;

  if (checkPaymentTestModeOn()) {
    nextQuery = {
      ...currentQuery,
      testPg: false,
    };
  } else {
    nextQuery = {
      ...currentQuery,
      testPg: true,
    };
  }

  const nextQueryString = Object.keys(nextQuery).length ? `?${qs.stringify(nextQuery)}` : '';
  const nextPathname = hashRoutingQuery
    ? generatePathnameForHashHistory(nextQueryString)
    : generatePathnameForBrowserHistory(nextQueryString);

  window.history.pushState({}, '', nextPathname);
};
